<template>
  <div >
    <img v-if="app.icon" :src='app.icon' style='height: 40px;margin-right: 10px;border-radius: 5px;'>
    <span>{{app.app_name?app.app_name:('无效应用'+appId)}}</span>
  </div>
</template>

<script>
export default {
  name: "ApplicationShow",
  props:["applicationList","appId"],
  data(){
    return {
      app:{}
    }
  },
  watch:{
    appId:{
      handler(newName, oldName) {
        let _index = this.$store.getters.getAppAll.findIndex(item=>{
          return this.appId===item.app_id
        })
        if (_index!==-1)
          this.app = this.$store.getters.getAppAll[_index]
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/V1/ApplicationShow.vue